import * as React from "react";
import {
  Dropdown,
  IDropdownOption,
  IDropdownStyles,
} from "@fluentui/react/lib/Dropdown";
import RbLabel from "../../../../bosch-react/components/label/RbLabel";
import RbButton, {
  ButtonSize,
  ButtonType,
} from "../../../../bosch-react/components/button/RbButton";
import { getDivisionsList } from "../../../../services/commonServices";
import { IDivision } from "../../../Admin/Managements/Division/types";

class Search_Refinement_Division extends React.Component<any, any> {
  //public options: any[] = [];
  constructor(props: any) {
    super(props);
    this.state = {
      IsShown: false,
      Divisions: [],
      SelectedDivision: [],
      isClickToRemove: false,
    };
    //this.handleSearch = this.handleSearch.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  async componentDidMount() {
    //this.setState({SelectedDivision: [{key: "BSH"},{key: "RBEI"}]});
    let response = await getDivisionsList();
    let divisions: IDivision[] = !!(response.data) && response.data;
    let rs: any[] = [];
    divisions.forEach((division) => {
      rs.push({
        key: division.title,
        text: division.longTitle,
      });
    });
    rs.unshift({ key: "All", text: "--- All ---" });
    let updatedObj: any = {
      Divisions: rs,
    };

    updatedObj["SelectedDivision"] =
      this.props.inputDivision !== ""
        ? this.props.inputDivision.split(",")
        : ["All"];
    this.setState(updatedObj);
  }

  render() {
    const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
      //const option = options[0];
      let result: JSX.Element[] = [];
      !!options && options.forEach((option, index) => {
        if (option.key === "All") {
          result = [];
          result.push(
            <div
              key={index}
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                textAlign: "center",
              }}
              className="a-chip -btnClose"
              role="button"
              aria-labelledby="chip-label-id"
              onClick={(e) => {
                if (e.currentTarget.innerText === "All") {
                  this.setState({
                    SelectedDivision: [],
                  });
                }
              }}
            >
              <span id="chip-label-id" className="a-chip__label">
                {option.key}
              </span>
              <div className="a-chip__close"></div>
            </div>
          );
        } else {
          result.push(
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                textAlign: "center",
              }}
              key={index}
              className="a-chip -btnClose"
              role="button"
              aria-labelledby="chip-label-id"
              onClick={(e) => {
                let divisions = [];
                divisions = this.state.SelectedDivision.filter(
                  (item: any) => item !== e.currentTarget.innerText
                );
                this.setState({
                  SelectedDivision: divisions,
                });
              }}
            >
              <span id="chip-label-id" className="a-chip__label">
                {option.key}
              </span>
              <div className="a-chip__close"></div>
            </div>
          );
        }
      });
      return <React.Fragment>{result}</React.Fragment>;
    };

    const dropdownStyles: Partial<IDropdownStyles> = {
      title: [
        { flexWrap: "wrap" },
        { display: "flex" },
        { position: "relative" },
        { flexWrap: "wrap" },
        { alignItems: "center" },
        { boxSizing: "border-box" },
        { minHeight: "30px" },
        { minWidth: "180px" },
        { height: "auto !important" },
        { minHeight: "66px !important" },
      ],
      //title: [{display: "table-cell"}, {whiteSpace: "break-spaces"}, {backgroundColor: "white !important"}, {borderBottom: "0px !important"}],
      //dropdown: [{borderBottom: "0px"}],
      label: { height: "auto !important" },
      //dropdown: [{borderRadius: "2px"}]
    };
    const dropdownRef = React.createRef<any>();
    const onSetFocus = () => {
      dropdownRef.current.state.isOpen = this.state.isClickToRemove;
    };
    return (
      <React.Fragment>
        <div className="ms-Grid" style={{ marginBottom: "1.5rem" }}>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <RbLabel hasPadding={true}>Division</RbLabel>
              <Dropdown
                multiSelect
                selectedKeys={this.state.SelectedDivision}
                //placeholder="--- All ---"
                options={this.state.Divisions}
                onChange={this.onChange}
                styles={dropdownStyles}
                onRenderTitle={onRenderTitle}
                onClick={(event) => {
                  onSetFocus();
                }}
                componentRef={dropdownRef}
              />
            </div>
            <div className="ms-Grid-col ms-sm12" style={{ marginTop: "10px" }}>
              <RbButton
                type={ButtonType.Secondary}
                size={ButtonSize.Tiny}
                label="Refine"
                style={{ minWidth: "3rem" }}
                onClick={this.handleSearch}
              />
              <RbButton
                type={ButtonType.Secondary}
                size={ButtonSize.Tiny}
                label="Clear"
                style={{ minWidth: "3rem" }}
                onClick={this.clearSearch}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
  onChange = (
    event: React.FormEvent<HTMLDivElement>,
    item?: IDropdownOption<any>,

  ): void => {
    if (!!item) {
      if (item.key === "All") {
        this.setState({
          SelectedDivision: item.selected
            ? [item.key]
            : this.state.SelectedDivision.filter(
              (key: string | number) => key !== item.key
            ),
        });
      } else {
        if (this.state.SelectedDivision[0] === "All") {
          this.setState({
            SelectedDivision: item.selected
              ? [item.key as string]
              : this.state.SelectedDivision.filter(
                (key: string | number) => key !== item.key
              ),
          });
        } else {
          this.setState({
            SelectedDivision: item.selected
              ? [...this.state.SelectedDivision, item.key as string]
              : this.state.SelectedDivision.filter(
                (key: string | number) => key !== item.key
              ),
          });
        }
      }
    }
  };
  handleSearch() {
    let options: string = "";
    if (this.state.SelectedDivision.length === 1) {
      if (this.state.SelectedDivision[0] === "All") {
        this.props.handleSearch("division", "");
      } else {
        this.props.handleSearch("division", this.state.SelectedDivision[0]);
      }
    } else if (this.state.SelectedDivision.length === 0) {
      this.props.handleSearch("division", "");
    } else {
      for (let i = 0; i < this.state.SelectedDivision.length; i++) {
        options+=`${this.state.SelectedDivision[i]},`
      }
      this.props.handleSearch("division", options.slice(0,-1));
    }
  }

  clearSearch() {
    this.setState({
      SelectedDivision: ["All"],
    });
    this.props.handleSearch("division", "");
  }
}

export default Search_Refinement_Division;
